import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  inject,
} from "@angular/core";
import { RouterModule } from "@angular/router";

import { SpinnerService } from "./shared/services/spinner/spinner.service";

@Component({
  selector: "app-root",
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements AfterContentChecked {
  constructor(
    private changeDetectionRef: ChangeDetectorRef,
    private router: RouterModule
  ) {}

  public spinner = inject(SpinnerService);

  loadingConfig = { backdropBorderRadius: "3px", fullScreenBackdrop: true };

  ngAfterContentChecked(): void {
    this.changeDetectionRef.detectChanges();
  }
}
